import DefectAccessoriesImage from '@/assets/img/defect-accessories.svg';
import DefectApparelImage from '@/assets/img/defect-apparel.svg';
import DefectShoeImage from '@/assets/img/defect-shoe.svg';
import InnerTagAccessoriesImage from '@/assets/img/inner-tag-accessories.svg';
import InnerTagApparelImage from '@/assets/img/inner-tag-apparel.svg';
import InnerTagShoeImage from '@/assets/img/inner-tag-shoe.svg';
import SolesShoeImage from '@/assets/img/soles-shoe.svg';
import type { ImageSlotConfig } from '@/types/case.interface';

import { CaseImageType, ProductMainGroups } from '@onrunning/backstage-models';

/**
 * Configures slot positions and background images for each `CaseImageType`.
 * Ensures that every image type has a predefined, structured slot assignment.
 */
export const imageSlotConfig: Record<CaseImageType, ImageSlotConfig> = {
  [CaseImageType.SolesShoe]: { position: 1, background: SolesShoeImage, label: 'shoes.soles' },
  [CaseImageType.InnerTagShoe]: { position: 2, background: InnerTagShoeImage, label: 'shoes.inner_tag' },
  [CaseImageType.DefectShoes]: { position: 3, background: DefectShoeImage, label: 'shoes.defect' },
  [CaseImageType.InnerTagApparel]: { position: 1, background: InnerTagApparelImage, label: 'apparel.inner_tag' },
  [CaseImageType.DefectApparel]: { position: 2, background: DefectApparelImage, label: 'apparel.defect' },
  [CaseImageType.InnerTagAccessories]: {
    position: 1,
    background: InnerTagAccessoriesImage,
    label: 'accessories.inner_tag',
  },
  [CaseImageType.DefectAccessories]: { position: 2, background: DefectAccessoriesImage, label: 'accessories.defect' },
};

/**
 * Maps `ProductMainGroups` to a `Map<number, CaseImageType>`, ensuring
 * consistent image slot assignments.
 * This mapping is built using `imageSlotConfig`, ensuring the slot
 * positions are always referenced dynamically instead of being hardcoded.
 */
export const productImageSlots = new Map<ProductMainGroups, Map<number, CaseImageType>>([
  [
    ProductMainGroups.shoes,
    new Map([
      [imageSlotConfig[CaseImageType.SolesShoe].position, CaseImageType.SolesShoe],
      [imageSlotConfig[CaseImageType.InnerTagShoe].position, CaseImageType.InnerTagShoe],
      [imageSlotConfig[CaseImageType.DefectShoes].position, CaseImageType.DefectShoes],
    ]),
  ],
  [
    ProductMainGroups.apparel,
    new Map([
      [imageSlotConfig[CaseImageType.InnerTagApparel].position, CaseImageType.InnerTagApparel],
      [imageSlotConfig[CaseImageType.DefectApparel].position, CaseImageType.DefectApparel],
    ]),
  ],
  [
    ProductMainGroups.accessories,
    new Map([
      [imageSlotConfig[CaseImageType.InnerTagAccessories].position, CaseImageType.InnerTagAccessories],
      [imageSlotConfig[CaseImageType.DefectAccessories].position, CaseImageType.DefectAccessories],
    ]),
  ],
]);
